import React from "react";
import { toast } from "react-toastify";
import MembershipToast from "./MembershipToast";

const MembershipForm = ({ onBack }) => {
  const handleSubmit = (e) => {
    e.preventDefault();

    toast(
      <MembershipToast toastId="membership-toast" onBack={onBack} />, // ⛔ Don't worry about "undefined" here, we'll fix it below
      {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        icon: false,
        toastId: "membership-toast", // ✅ use a fixed ID
      }
    );
  };

  return (
    <section className="section" id="membership-form">
      <h2>Apply for Membership</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Full Name:
          <input type="text" required />
        </label>
        <label>
          Email:
          <input type="email" required />
        </label>
        <label>
          Phone:
          <input type="tel" />
        </label>
        <div style={{ marginTop: "1rem" }}>
          <button type="submit" className="button">
            Submit Application
          </button>
          <button
            type="button"
            className="button"
            style={{ marginLeft: "1rem", backgroundColor: "#555" }}
            onClick={onBack}
          >
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
};

export default MembershipForm;
